import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import ErrorIcon from "@mui/icons-material/Error"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { Box, CircularProgress, Tooltip } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { BrowserPrintHealth } from "./browserPrintHealth"

type BrowserPrintStatusIconProps = {
  health: BrowserPrintHealth
  size?: number
}

/** Green = ready, amber = agent up but no default printer, red = agent unreachable. */
export const BrowserPrintStatusIcon: FC<BrowserPrintStatusIconProps> = ({
  health,
  size = 18,
}) => {
  const { t } = useTranslation()
  const title =
    health.status === "ready" && health.printer?.name
      ? t("browserPrintStatus.readyWithPrinter", { name: health.printer.name })
      : t(`browserPrintStatus.${health.status}`)

  const icon =
    health.status === "checking" ? (
      <CircularProgress size={size - 4} />
    ) : health.status === "ready" ? (
      <CheckCircleIcon color="success" sx={{ fontSize: size }} />
    ) : health.status === "noPrinter" ? (
      <WarningAmberIcon color="warning" sx={{ fontSize: size }} />
    ) : (
      <ErrorIcon color="error" sx={{ fontSize: size }} />
    )

  return (
    <Tooltip title={title}>
      <Box
        component="span"
        data-testid={`browser-print-status-${health.status}`}
        aria-label={title}
        sx={{ display: "inline-flex", alignItems: "center" }}
      >
        {icon}
      </Box>
    </Tooltip>
  )
}
